import { Shield, Network, Wifi, Phone, Camera, Server } from "lucide-react";

export const COMPANY = {
  name: "Beta-Tech Systems, Inc.",
  shortName: "Beta-Tech Systems",
  domain: "betatechsystems.com",
  tagline: "IT Service & Support for Baton Rouge Businesses",
  phone: "+1-225-774-7073",
  address: "Baton Rouge, Louisiana",
  paymentUrl: "https://buy.stripe.com/8wM9B56xV38R3gkeUU",
  logo: "/betatech-logo.png",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  {
    icon: Shield,
    title: "Firewalls",
    slug: "firewalls",
    short: "Provision, installation & servicing of business-grade firewalls.",
    body: "We deploy and manage enterprise firewall solutions that protect your network perimeter from intrusion, malware, and unauthorized access. From initial provisioning to ongoing rule management and monitoring, we keep your business defended.",
  },
  {
    icon: Network,
    title: "Networks",
    slug: "networks",
    short: "Design, installation & support for reliable wired networks.",
    body: "Structured cabling, switching, routing, and network segmentation built for performance and reliability. We design networks that scale with your business and troubleshoot issues before they cause downtime.",
  },
  {
    icon: Wifi,
    title: "WiFi",
    slug: "wifi",
    short: "Business WiFi that reaches every corner of your facility.",
    body: "Professional wireless surveys, access point installation, and tuning for seamless coverage. Whether it's an office, warehouse, or multi-floor building, we eliminate dead zones and keep everyone connected.",
  },
  {
    icon: Phone,
    title: "Telephone Systems",
    slug: "telephone-systems",
    short: "Modern phone systems — provision, installation & service.",
    body: "VoIP and traditional telephone systems provisioned, installed, and serviced end-to-end. Reliable business communications with the features your team needs and the support you can count on.",
  },
  {
    icon: Camera,
    title: "Surveillance Systems",
    slug: "surveillance-systems",
    short: "Camera & surveillance systems to protect your premises.",
    body: "IP camera systems, recording infrastructure, and remote viewing setup. We install and service surveillance solutions that give you clear visibility and peace of mind, on-site and remotely.",
  },
  {
    icon: Server,
    title: "Computer & Server Support",
    slug: "computer-server-support",
    short: "Full support for your computers and servers.",
    body: "Workstation and server provisioning, maintenance, and rapid troubleshooting. We keep your hardware healthy, your data backed up, and your team productive with responsive local support.",
  },
];
